/*
-------------x(w)COLS-------------->
|
|
|
y(h)ROWS
|
|
|
|
˅
*/

export function checkLayoutFilled(maxRows, maxCols, layout) {
  /*
  [
    {w: 12, h: 6, x: 0, y: 0} = 72,
    {w: 12, h: 6, x: 0, y: 6} = 72,
  ]
  [
    {w: 6, h: 12, x: 0, y: 0} = 72,
    {w: 6, h: 12, x: 6, y: 0} = 72,
  ]
  */
  const maxPoints = maxRows * maxCols;
  let points = 0;
  layout.map(gridItem => {
    points += gridItem.w * gridItem.h;
  });
  return points === maxPoints;
}

export function checkLayoutInBounds(maxRows, maxCols, layout) {
  let isValid = true;
  layout.map(gridItem => {
    isValid = !(gridItem.x > maxRows);
    isValid = !(gridItem.y > maxCols);
  });
  return isValid;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/validateChannelLayout.js